import { Component, Input } from '@angular/core';
import { SafePipe } from '@shared/pipes/safe.pipe';
import { ProgressSpinnerComponent } from '../progress-spinner/progress-spinner.component';

@Component({
  selector: 'app-content-viewer',
  imports: [SafePipe, ProgressSpinnerComponent],
  templateUrl: './content-viewer.component.html',
})
export class ContentViewerComponent {
  @Input() url: string = '';

  iframeLoaded: boolean = false;
}
